<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="文件名" prop="name">
        <el-input v-model="form.name" placeholder="请输入文件名" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象编码" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入关联对象编码" v-trim/>
      </el-form-item>
      <el-form-item label="类型0图片 1视频 2其他" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型0图片 1视频 2其他" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象类型 0SHE上报 1安全风险上报 2安全风险处理 3安全风险分配物业主管 4安全风险分配处理人 5DCA风险上报 6DCA风险处理" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入关联对象类型 0SHE上报 1安全风险上报 2安全风险处理 3安全风险分配物业主管 4安全风险分配处理人 5DCA风险上报 6DCA风险处理" v-trim/>
      </el-form-item>
      <el-form-item label="文件地址" prop="fileurl">
        <el-input v-model="form.fileurl" placeholder="请输入文件地址" v-trim/>
      </el-form-item>
      <el-form-item label="排序码" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      <el-form-item label="企业编码(关联company表）" prop="companyId">
        <el-input v-model="form.companyId" placeholder="请输入企业编码(关联company表）" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaMultifileWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        name: '',
        info: '',
        objId: '',
        type: '',
        objType: '',
        fileurl: '',
        sortnum: '',
        companyId: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/multifile',
      'field.id': 'id'
    })
  }
}
</script>
